import styled from '@emotion/styled';
import { Alert, Divider, ModalActions, Modal as ModalBase } from '@ui-components/neo.tax';

export const StyledModalActions = styled(ModalActions)({
  paddingTop: 0,
});

export const StyledDivider = styled(Divider)({
  margin: '18px 0',
});

interface StyledAlertProps {
  $withTopMargin?: boolean;
}

export const StyledAlert = styled(Alert)<StyledAlertProps>(({ $withTopMargin }) => ({
  marginTop: $withTopMargin ? '16px' : 0,
}));

export const Modal = styled(ModalBase)({
  maxWidth: '515px',
  width: '100%',
});
